import { Checkbox, Drawer, TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./assets/css/vesselsDrawer.module.css";
import { Button, Form, Spinner } from "react-bootstrap";
import { vesselServices } from "../../Vessels/services/vessels.services";
import { decrypt } from "../../_helpers";

export default function VesselsDrawer({
  show,
  toggle,
  vessels,
  formik,
  template,
  setVessels,
  folderType,
  isDay,
  publicKey,
  privateKey,
}) {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [initialVessels] = useState(vessels);
  const onSelectRow = (id) => {
    setSelected(id);
  };
  const onSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (value === "") {
      setVessels(initialVessels);
    } else {
      const filteredVessels = initialVessels?.filter((vessel) =>
        vessel?.sheetname.toLowerCase().includes(value.toLowerCase()),
      );
      setVessels(filteredVessels);
    }
  };
  const setFormikBase = (details, folderType) => {
    if (isDay) {
      formik.setFieldValue(
        "45006844-88a3-437e-9542-5aee3fffb073",
        details?.vesselName,
      );

      formik.setFieldValue(
        "c87817af-9650-426e-a7fb-f6cdb132629d",
        details?.vesselIMO,
      );

      formik.setFieldValue(
        "31cf6cb1-38fa-4957-85ff-0b06739411fa",
        details?.vesselRegistryPort,
      );

      formik.setFieldValue(
        "25eeb678-6bda-4e1f-ae43-6fa9585ea833",
        details?.vesselFlag,
      );

      formik.setFieldValue(
        "a187bec6-35a0-4360-8896-807e87362ccf",
        details?.vesselLOA,
      );

      formik.setFieldValue(
        "8b1d6361-2ffd-4977-aaff-683278a38700",
        details?.vesselType,
      );

      formik.setFieldValue(
        "6b2e1513-9b92-4eb1-873e-f0e78fe0a438",
        details?.vesselSpecialConditions,
      );

      formik.setFieldValue(
        "433bf7e0-4bd3-44f9-bd99-ec41fd86bc86",
        details?.vesselServiceProvider,
      );
      formik.setFieldValue(
        "5b52253c-95f2-4d92-9b93-4573fe9ce298",
        details?.vesselServiceProviderAddress,
      );

      formik.setFieldValue(
        "2bc21d9e-48dc-4d50-88e9-bd7c9b4a31b7",
        details?.vesselServiceProviderInsuranceRef,
      );

      formik.setFieldValue(
        "7a43c954-275e-41b8-9b2e-c40a3ca67ae4",
        details?.vesselCentralAgent,
      );

      formik.setFieldValue(
        "5a334988-110f-46b0-9919-92f83df6ab56",
        details?.vesselCentralAgentAddress,
      );

      formik.setFieldValue(
        "439f1ffa-4394-4911-adda-15de1292ed5c",
        details?.vesselCentralAgentInsuranceRef,
      );

      formik.setFieldValue(
        "fe000409-83d3-4ed8-849f-ae7d0eccbb02",
        details?.vesselStakeholder,
      );

      formik.setFieldValue(
        "cea3d97a-9a79-47cb-994b-12fba36ae746",
        details?.vesselStakeholderAddress,
      );

      formik.setFieldValue(
        "3c631ba5-7c0b-4c9f-a42c-86acceb3f431",
        details?.vesselStakeholderInsuranceRef,
      );

      formik.setFieldValue(
        "433bf7e0-4bd3-44f9-bd99-ec41fd86bc86",
        details?.vesselServiceProvider,
      );

      formik.setFieldValue(
        "946773b7-952c-4aa5-818a-0226a44cfc9e",
        details?.vesselDayPassengersOnBoard,
      );
    } else {
      switch (folderType) {
        case "transport":
          formik.setFieldValue(
            "d23a3965-1af3-4419-a805-c44a064a1edb",
            details?.vesselName,
          );

          formik.setFieldValue(
            "88ccaf38-2ff0-4c5a-878b-e1a11fb11ef2",
            details?.vesselIMO,
          );

          formik.setFieldValue(
            "b540b9af-303d-4fb5-8d4b-c202b50b03b7",
            details?.vesselRegistryPort,
          );

          formik.setFieldValue(
            "cee28b8d-4efb-4c28-86e0-3a72d9da9720",
            details?.vesselFlag,
          );

          formik.setFieldValue(
            "d5b950b8-2324-423c-a99b-2e0a30dad17a",
            details?.vesselLOA,
          );

          formik.setFieldValue(
            "4cf0b121-f24c-497d-a42a-9c4d8949f6c5",
            details?.vesselType,
          );

          formik.setFieldValue(
            "106bb317-b8e3-4ace-9923-95ee807af9dd",
            details?.vesselSpecialConditions,
          );

          formik.setFieldValue(
            "c861db6d-8398-4062-b080-596b04fd34eb",
            details?.vesselServiceProviderAddress,
          );

          formik.setFieldValue(
            "4da3a605-2600-4b61-b732-f4f39909392a",
            details?.vesselServiceProviderCompany,
          );

          formik.setFieldValue(
            "ee3f5245-c7e7-48c5-b514-0565410996ee",
            details?.vesselServiceProviderInsuranceRef,
          );

          formik.setFieldValue(
            "ab22c676-c070-49c0-ad67-a1a812c13a8e",
            details?.vesselServiceProviderVAT,
          );

          formik.setFieldValue(
            "e67ea9ae-bc41-4874-b46c-3b44f7ebca6d",
            details?.vesselCentralAgent,
          );

          formik.setFieldValue(
            "e904671a-1bba-404e-adad-b45f134ec13b",
            details?.vesselCentralAgentAddress,
          );

          formik.setFieldValue(
            "b900f123-e2e2-40cb-a42e-696f3b92ed4c",
            details?.vesselCentralAgentCompany,
          );

          formik.setFieldValue(
            "e47bcb56-84a6-4a01-90f8-93d99e8af6be",
            details?.vesselCentralAgentMYBA,
          );

          formik.setFieldValue(
            "54f2735d-26a1-4daa-8ad8-341ef16bb5f5",
            details?.vesselCentralAgentVAT,
          );

          formik.setFieldValue(
            "b53fb877-341a-456f-8588-506b08f8bbe0",
            details?.vesselStakeholder,
          );

          formik.setFieldValue(
            "f8258c89-6534-421c-8ae0-c83b0b530150",
            details?.vesselStakeholderAddress,
          );

          formik.setFieldValue(
            "20bed7e4-bb15-43fa-b423-6fb99ef85240",
            details?.vesselStakeholderCompany,
          );

          formik.setFieldValue(
            "702363d1-1546-42e1-bc04-4d5b3a5a7f21",
            details?.vesselStakeholderMYBA,
          );

          formik.setFieldValue(
            "2c5e4f8e-efc5-465a-9af6-2fa6f68204ba",
            details?.vesselStakeholderVAT,
          );

          formik.setFieldValue(
            "52c7830b-7d66-4743-b492-f3a08363aefc",
            details?.vesselStakeholderInsuranceRef,
          );

          formik.setFieldValue(
            "44abe5a4-6654-4431-80a9-57f1a206598e",
            details?.vesselStakeholderFinancialGuarantee,
          );

          formik.setFieldValue(
            "48e38c08-3a81-42d8-87dd-7dfb9b2d2dab",
            details?.vesselMaxPassengersWithStaterooms,
          );
          formik.setFieldValue(
            "1d2ad65e-57b6-437e-a1b1-8bec31b7cc48",
            details?.vesselDayPassengersOnBoard,
          );

          formik.setFieldValue(
            "ddbe29b9-6236-4c8b-aafe-d3146a9a9aae",
            details?.vesselServiceProvider,
          );
          formik.setFieldValue(
            "c8c4c1c9-7c0e-4e3b-9b3a-4f0e1fd71b4e",
            details?.vesselCentralAgentInsuranceRef,
          );

          break;

        case "charter":
          formik.setFieldValue(
            "14effde2-5e1e-41c7-b934-ad43316ef30c",
            details?.vesselName,
          );

          formik.setFieldValue(
            "c9f359fb-7f92-452b-9c81-8cf32ea8e111",
            details?.vesselIMO,
          );

          formik.setFieldValue(
            "cf2bafbf-a20e-4f03-a121-25aa30a48952",
            details?.vesselRegistryPort,
          );

          formik.setFieldValue(
            "cdf304cd-1e10-4ca4-9037-7f6112863d91",
            details?.vesselFlag,
          );

          formik.setFieldValue(
            "a3b26a2d-e010-45d2-8b57-50f00bae109d",
            details?.vesselLOA,
          );

          formik.setFieldValue(
            "d7b29ac8-7b37-463d-aaab-0128de8cb571",
            details?.vesselType,
          );

          formik.setFieldValue(
            "64bae275-6bf1-4125-9008-0afef2600162",
            details?.vesselSpecialConditions,
          );

          formik.setFieldValue(
            "4b65055d-b42a-4953-84a3-0bea29b81b39",
            details?.vesselCentralAgent,
          );

          formik.setFieldValue(
            "53abd5de-7bfd-4361-8d5c-e1318c438999",
            details?.vesselCentralAgentAddress,
          );

          formik.setFieldValue(
            "82b42f40-4d1e-4c30-a00c-526101327a44",
            details?.vesselCentralAgentCompany,
          );

          formik.setFieldValue(
            "7de58e94-309b-499c-988b-8f33e25b5cd1",
            details?.vesselCentralAgentVAT,
          );

          formik.setFieldValue(
            "7303da73-268a-429f-862c-804724af3b43",
            details?.vesselStakeholder,
          );

          formik.setFieldValue(
            "34fc430a-dfec-4968-80f1-d0dde6c0ecae",
            details?.vesselStakeholderAddress,
          );

          formik.setFieldValue(
            "658e775b-2286-47e7-9538-4625c8896c7e",
            details?.vesselStakeholderCompany,
          );

          formik.setFieldValue(
            "07a325d0-78c3-47bb-99f7-a1b5e761b30b",
            details?.vesselStakeholderVAT,
          );

          formik.setFieldValue(
            "e785e3fd-8ada-4aa7-838f-c6d4508ae5a3",
            details?.vesselStakeholderInsuranceRef,
          );

          formik.setFieldValue(
            "4a84c7da-57f7-4e32-a82f-d4295d2a1f3c",
            details?.vesselStakeholderFinancialGuarantee,
          );

          formik.setFieldValue(
            "0b6b9aab-1692-4e7b-b283-2d83586ae4c7",
            details?.vesselMaxPassengersWithStaterooms,
          );
          formik.setFieldValue(
            "5b0eaa69-6639-4ae2-9a13-a1a8386e910c",
            details?.vesselDayPassengersOnBoard,
          );
          formik.setFieldValue(
            "d2535788-414d-45dc-bd26-cf0d1b8b0deb",
            details?.vesselServiceProvider,
          );

          formik.setFieldValue(
            "50a9b67c-9dad-4e81-9a94-95260d22b0ca",
            details?.vesselServiceProviderAddress,
          );

          formik.setFieldValue(
            "b0b340bb-0d5c-47d1-9688-2cf5b69c93e6",
            details?.vesselServiceProviderCompany,
          );

          formik.setFieldValue(
            "3c9e170b-fbdd-4fb1-a94d-896711d15619",
            details?.vesselServiceProviderInsuranceRef,
          );
          formik.setFieldValue(
            "be6f7fb6-0faa-476e-86a3-1d8a6dca14ba",
            details?.vesselServiceProviderVAT,
          );
          formik.setFieldValue(
            "f3a6c2d8-9b41-4f7e-a2c9-7e13b4a8cf02",
            details?.vesselCentralAgentInsuranceRef,
          );

          break;

        default:
          break;
      }
    }
  };
  const onSubmitBase = async () => {
    try {
      setIsLoading(true);
      const response = await vesselServices.getVesselById(selected);
      const vessel = response?.vessel;
      const decryptPublicKey = vessel?.isAssociated
        ? vessel?.vesselPublicKey
        : publicKey;
      const decryptSecretKey = vessel?.isAssociated
        ? vessel?.vesselSecretKey
        : privateKey;

      const details = {
        sheetName: decrypt(
          vessel?.sheetName,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselName: decrypt(
          vessel?.vesselName,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselIMO: decrypt(
          vessel?.vesselIMO,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselRegistryPort: decrypt(
          vessel?.vesselRegistryPort,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselFlag: decrypt(
          vessel?.vesselFlag,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselType: decrypt(
          vessel?.vesselType,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselLOA: decrypt(
          `${vessel?.vesselLOA}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselMaxPassengersWithStaterooms: decrypt(
          `${vessel?.vesselMaxPassengersWithStaterooms}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselDayPassengersOnBoard: decrypt(
          `${vessel?.vesselDayPassengersOnBoard}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProvider: decrypt(
          vessel?.vesselServiceProvider,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderAddress: decrypt(
          vessel?.vesselServiceProviderAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderCompany: decrypt(
          `${vessel?.vesselServiceProviderCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderInsuranceRef: decrypt(
          vessel?.vesselServiceProviderInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderVAT: decrypt(
          vessel?.vesselServiceProviderVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgent: decrypt(
          vessel?.vesselCentralAgent,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentAddress: decrypt(
          vessel?.vesselCentralAgentAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentCompany: decrypt(
          `${vessel?.vesselCentralAgentCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentInsuranceRef: decrypt(
          vessel?.vesselCentralAgentInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentVAT: decrypt(
          vessel?.vesselCentralAgentVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentMYBA: decrypt(
          vessel?.vesselCentralAgentMYBA,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholder: decrypt(
          vessel?.vesselStakeholder,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderAddress: decrypt(
          vessel?.vesselStakeholderAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderCompany: decrypt(
          `${vessel?.vesselStakeholderCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderInsuranceRef: decrypt(
          vessel?.vesselStakeholderInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderMYBA: decrypt(
          vessel?.vesselStakeholderMYBA,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderVAT: decrypt(
          vessel?.vesselStakeholderVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderFinancialGuarantee: decrypt(
          vessel?.vesselStakeholderFinancialGuarantee,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselSpecialConditions: decrypt(
          vessel?.vesselSpecialConditions,
          decryptPublicKey,
          decryptSecretKey,
        ),
      };
      setFormikBase(details, folderType);
      setIsLoading(false);
      toggle();
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };
  const setFormikAgencyAgreement = (details) => {
    formik.setFieldValue(
      "fffd1237-0d7e-4a3b-a9a7-8cf1d4f61d58",
      details?.vesselName,
    );

    formik.setFieldValue(
      "b95da880-62f4-42dc-aa25-ae0d2acb2acb",
      details?.vesselIMO,
    );

    formik.setFieldValue(
      "03172b71-730f-49a6-a44b-6775a4fce3d5",
      details?.vesselFlag,
    );

    formik.setFieldValue(
      "4ba89a8e-bacd-4c39-8759-3d092620087c",
      details?.vesselLOA,
    );

    formik.setFieldValue(
      "1a8914c4-1648-4a8e-b310-83cdb3a52cc9",
      details?.vesselType,
    );
  };
  const onSubmitAgencyAgreement = async () => {
    try {
      console.log("onSubmit agency template", template);
      setIsLoading(true);
      const response = await vesselServices.getVesselById(selected);
      const vessel = response?.vessel;
      const decryptPublicKey = vessel?.isAssociated
        ? vessel?.vesselPublicKey
        : publicKey;
      const decryptSecretKey = vessel.isAssociated
        ? vessel?.vesselSecretKey
        : privateKey;
      const details = {
        sheetName: decrypt(
          vessel?.sheetName,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselName: decrypt(
          vessel?.vesselName,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselIMO: decrypt(
          vessel?.vesselIMO,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselRegistryPort: decrypt(
          vessel?.vesselRegistryPort,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselFlag: decrypt(
          vessel?.vesselFlag,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselType: decrypt(
          vessel?.vesselType,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselLOA: decrypt(
          `${vessel?.vesselLOA}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselMaxPassengersWithStaterooms: decrypt(
          `${vessel?.vesselMaxPassengersWithStaterooms}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselDayPassengersOnBoard: decrypt(
          `${vessel?.vesselDayPassengersOnBoard}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProvider: decrypt(
          vessel?.vesselServiceProvider,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderAddress: decrypt(
          vessel?.vesselServiceProviderAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderCompany: decrypt(
          `${vessel?.vesselServiceProviderCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderInsuranceRef: decrypt(
          vessel?.vesselServiceProviderInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselServiceProviderVAT: decrypt(
          vessel?.vesselServiceProviderVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgent: decrypt(
          vessel?.vesselCentralAgent,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentAddress: decrypt(
          vessel?.vesselCentralAgentAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentCompany: decrypt(
          `${vessel?.vesselCentralAgentCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentInsuranceRef: decrypt(
          vessel?.vesselCentralAgentInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentVAT: decrypt(
          vessel?.vesselCentralAgentVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselCentralAgentMYBA: decrypt(
          vessel?.vesselCentralAgentMYBA,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholder: decrypt(
          vessel?.vesselStakeholder,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderAddress: decrypt(
          vessel?.vesselStakeholderAddress,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderCompany: decrypt(
          `${vessel?.vesselStakeholderCompany}`,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderInsuranceRef: decrypt(
          vessel?.vesselStakeholderInsuranceRef,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderMYBA: decrypt(
          vessel?.vesselStakeholderMYBA,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderVAT: decrypt(
          vessel?.vesselStakeholderVAT,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselStakeholderFinancialGuarantee: decrypt(
          vessel?.vesselStakeholderFinancialGuarantee,
          decryptPublicKey,
          decryptSecretKey,
        ),
        vesselSpecialConditions: decrypt(
          vessel?.vesselSpecialConditions,
          decryptPublicKey,
          decryptSecretKey,
        ),
      };
      setFormikAgencyAgreement(details);
      setIsLoading(false);
      toggle();
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    }
  };

  return (
    <Drawer open={show} onClose={toggle} anchor="right">
      <div className={classes.drawer}>
        <span className={classes.title}>{t("Select one vessel sheet")}</span>
        <Form.Control
          type="text"
          placeholder={t("Search ...")}
          value={searchText}
          onChange={onSearch}
        />
        {vessels?.map((vessel) => {
          return (
            <TableRow className={classes["MuiTableRow-root"]}>
              <TableCell
                padding="checkbox"
                className={classes["MuiTableCell-root"]}
              >
                <Checkbox
                  color="primary"
                  inputProps={{
                    "aria-label": "select all desserts",
                  }}
                  onChange={() => onSelectRow(vessel?.id)}
                  checked={selected === vessel?.id}
                />
              </TableCell>
              <TableCell className={classes["MuiTableCell-root"]}>
                {vessel?.is_associated
                  ? decrypt(
                      vessel?.sheetname,
                      vessel?.vessel_public_key,
                      vessel?.vessel_secret_key,
                    )
                  : decrypt(vessel?.sheetname, publicKey, privateKey)}
              </TableCell>
            </TableRow>
          );
        })}
      </div>
      <Button
        className={classes["btn-drawer"]}
        onClick={
          template === "agencyAgreement"
            ? onSubmitAgencyAgreement
            : onSubmitBase
        }
        disabled={isLoading}
      >
        {isLoading && <Spinner animation="border" size="sm" />}
        <span>{t("Select")}</span>
      </Button>
    </Drawer>
  );
}
